import Vue from 'vue'
import Router from 'vue-router'
import store from '../services/index'
//Common
import Paarivallal from '../members/Paarivallal.vue'
import Signin from '../common/Signin.vue'
import Signup from '../common/Signup.vue'
import Forgot from '../common/Forgot.vue'
import ThankYou from '../common/ThankYou.vue'
import Successfull_Signup from '../common/Successfull_Signup.vue'
import Successfull from '../common/Successfull'
import Enroll from '../common/Enroll.vue'
import Committee from '../common/Members.vue'
import Financials from '../common/Financials'
import YouthCommittee from '../common/YouthCommittee'
import Mission from '../common/Mission'
import Donors from '../common/Donors'
import VerifyEmail from '../common/VerifyEmail'
import Register from '../common/Register'
import PhotoGallery from '../common/PhotoGallery'
import Documents from '../common/Documents'
import VaagaiMalar2026 from '../common/VaagaiMalar2026.vue'
import MemberPayments from '../common/MemberPayments'
import NonMemberPayments from '../common/NonMemberPayments'
import VerifyInPortal from '../events/VerifyInPortal'
import ProgramChanges from '../events/ProgramChanges'
import ReserveMe from '../events/ReserveMe'
import VIV from '../events/VIV.vue'
import SpecialEvent from '../events/SpecialEvent.vue'
import qrcode from '../common/qrcode.vue'
import cltevents from '../members/cltevents.vue'
// misc
import PVSA from '../misc/PVSA'
import FileManager from '../utility/FileManager'
import Sponsors from '../misc/Sponsors'
//User
import FamilyInfo from '../members/FamilyInfo.vue'
import Contactus from '../members/Contactus.vue'
//Admin
import MembershipList from '../admin/MembershipList.vue'
import UserManagement from '../admin/UserManagement.vue'
import Subscribers from '../admin/Subscribers'
import ManageGallery from '../admin/ManageGallery'
import Volunteers from '../admin/Volunteers'
import AddEventMember from '../events/AddEventMember'
import MyPrograms from '../events/MyPrograms'
import ManageSponsors from '../admin/ManageSponsors'
//EventManagement
import userProfile from '../members/UserProfile'
import MyEvents from '../members/MyEvents'
//Member
import Events from '../members/NewEvents'
import Vanambadi from '../members/Vaanampaadi'
import EventCheckIn from '../events/EventCheckIn.vue'
import Participant from '../events/Participant'
//payment methods
import PaymentGateway from '../admin/PaymentGateway'
import SendEmail from '../admin/SendEmail'
import Faq from '../common/Faq.vue'
import schedule from '../events/schedule.vue'
import RegisteredTeams from '../members/RegisteredTeams.vue'
import ProgramSchedule from '../events/ProgramSchedule.vue'

Vue.use(Router)

// Admin-section
const superAdminMiddleware = (to, from, next) => {
  var user = store.getters.email
  var role = store.getters.role
  if (user && (role === "SuperAdmin" )){
    next()
  } else {
    next('/Signin')
  }
}
// Admin-section
const adminMiddleware = (to, from, next) => {
  var user = store.getters.email
  var role = store.getters.role
  if (user && (role === "Admin" || role === "SuperAdmin"  )){
    next()
  } else {
    next('/Signin')
  }
}
//Member-section
const memware = (to, from, next) => {
  var user = store.getters.email
  if (user){
    next()
  } else {
    next('/Signin')
  }
}

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    //Common
    { path: '/RegisteredTeams', name: 'RegisteredTeams', component: RegisteredTeams },
    { path: '/', name: 'Enroll', component: Enroll },
    { path: '/Enroll', name: 'Enroll', component: Enroll },
    { path: '/Signup', name: 'Signup', component: Signup },
    { path: '/Signin', name: 'Signin', component: Signin },
    { path: '/Forgot', name: 'Forgot', component: Forgot },
    { path: '/Register', name: 'Register', component: Register },
    { path: '/ThankYou', name: 'ThankYou', component: ThankYou },
    { path: '/Contactus', name: 'Contactus', component: Contactus },
    { path: '/Successfull', name: 'Successfull', component: Successfull },
    { path: '/Successfull_Signup', name: 'Successfull_Signup', component: Successfull_Signup },
    { path: '/Committee', name: 'Committee', component: Committee },
    { path: '/Financials', name: 'Financials', component: Financials },
    { path: '/YouthCommittee', name: 'YouthCommittee', component: YouthCommittee },
    { path: '/Mission', name: 'Mission', component: Mission },
    { path: '/Events', name: 'Events', component: Events },
    { path: '/Vanambadi', name: 'Vanambadi', component: Vanambadi },
    { path: '/Donors', name: 'Donors', component: Donors },
    { path: '/PaymentGateway', name: 'PaymentGateway', component: PaymentGateway },
    { path: '/VerifyEmail', name: 'VerifyEmail', component: VerifyEmail },
    { path: '/PVSA', name: 'PVSA', component: PVSA },
    { path: '/Sponsors', name: 'Sponsors', component: Sponsors },
    { path: '/PhotoGallery', name: 'PhotoGallery', component: PhotoGallery },
    { path: '/Documents', name: 'Documents', component: Documents },
    { path: '/VaagaiMalar2026', name: 'VaagaiMalar2026', component: VaagaiMalar2026 },
    { path: '/Paarivallal', name: 'Paarivallal', component: Paarivallal },
    { path: '/MemberPayments', name: 'MemberPayments', component: MemberPayments },  
    { path: '/NonMemberPayments', name: 'NonMemberPayments', component: NonMemberPayments },  
    { path: '/VerifyInPortal', name: 'VerifyInPortal', component: VerifyInPortal },  
    { path: '/ProgramChanges', name: 'ProgramChanges', component: ProgramChanges },  
    { path: '/ReserveMe', name: 'ReserveMe', component: ReserveMe },
    { path: '/VIV', name: 'VIV', component: VIV },
    { path: '/Faq', name: 'Faq', component: Faq },
    { path: '/qrcode', name: 'qrcode', component: qrcode },
    { path: '/schedule', name: 'schedule', component: schedule },
    { path: '/cltevents', name: 'cltevents', component: cltevents },
    { path: '/ProgramSchedule', name: 'ProgramSchedule', component: ProgramSchedule },
    { path: '/ManageSponsors', name: 'ManageSponsors', component: ManageSponsors,beforeEnter: adminMiddleware  },
    //Member
    { path: '/userProfile', name: 'userProfile', component: userProfile, beforeEnter: memware },
    { path: '/MyEvents', name: 'Events', component: MyEvents, beforeEnter: memware },
    //Admin
    { path: '/MembershipList', name: 'MembershipList', component: MembershipList, beforeEnter: adminMiddleware },
    { path: '/FamilyInfo', name: 'FamilyInfo', component: FamilyInfo, beforeEnter: adminMiddleware  },
    { path: '/Subscribers', name: 'Subscribers', component: Subscribers, beforeEnter: adminMiddleware  },
    { path: '/EventCheckIn', name: 'EventCheckIn', component: EventCheckIn, beforeEnter: adminMiddleware  },
    { path: '/Participant', name: 'Participant', component: Participant, beforeEnter: adminMiddleware  },
    { path: '/ManageGallery', name: 'ManageGallery', component: ManageGallery, beforeEnter: adminMiddleware  },
    { path: '/FileManager', name: 'FileManager', component: FileManager, beforeEnter: adminMiddleware  },  
    { path: '/Volunteers', name: 'Volunteers', component: Volunteers, beforeEnter: adminMiddleware  },  
    { path: '/MyPrograms', name: 'MyPrograms', component: MyPrograms,beforeEnter: adminMiddleware  },
    //SuperAdmin
    { path: '/UserManagement', name: 'UserManagement', component: UserManagement, beforeEnter: superAdminMiddleware  },
    { path: '/SendEmail', name: 'SendEmail', component: SendEmail,beforeEnter: superAdminMiddleware  },
    { path: '/AddEventMember', name: 'AddEventMember', component: AddEventMember,beforeEnter: superAdminMiddleware  },
    { path: '/SpecialEvent', name: 'SpecialEvent', component: SpecialEvent,beforeEnter: superAdminMiddleware  }
  ]
})

export default router
